export function emsFunc() {
  // Google翻訳が適用されているかチェック
  function checkTranslation() {
    const htmlElement = document.documentElement;
    const isTranslated = htmlElement.classList.contains('translated-ltr') || 
                        htmlElement.getAttribute('lang') === 'en' ||
                        htmlElement.querySelector('[dir="auto"]') !== null;
    
    const img = document.getElementById('quality-image');
    if (!img) return;
    
    if (isTranslated) {
      // 英語画像に切り替え
      if (img.getAttribute('data-en-src')) {
        img.src = img.getAttribute('data-en-src');
      } else if (window.qualityImgEn) {
        img.src = window.qualityImgEn;
      }
    } else {
      // 日本語画像に切り替え
      if (img.getAttribute('data-ja-src')) {
        img.src = img.getAttribute('data-ja-src');
      }
    }
  }
  
  // 初回チェック
  checkTranslation();
  
  // Google翻訳の変更を監視
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'class' || mutation.attributeName === 'lang')) {
        checkTranslation();
      }
    });
  });
  
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'lang']
  });
}